export class Currency {
    _value;
    static locale = "en-US";
    static currency = "USD";
    constructor(value) {
        this._value = value ?? 0;
        Object.freeze(this);
    }
    get value() {
        return this._value;
    }
    get isZero() {
        return this.value === 0;
    }
    toString(minFractionDigits = 2, maxFractionDigits = 2) {
        return new Intl.NumberFormat(Currency.locale, {
            style: "currency",
            currency: Currency.currency,
            minimumFractionDigits: minFractionDigits,
            maximumFractionDigits: maxFractionDigits,
        }).format(this.value);
    }
    toStringOrPlaceholder(minFractionDigits = 2, maxFractionDigits = 2, zeroPlaceholder = "-") {
        return this.isZero
            ? zeroPlaceholder
            : this.toString(minFractionDigits, maxFractionDigits);
    }
    valueOf() {
        return this._value;
    }
}
